<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card :loading="loading">
          <v-card-title>
            Availability File List for {{pmsConnDetails.usr}}
          </v-card-title>
          <v-card-subtitle>{{pmsConnDetails.pmsType}}</v-card-subtitle>


<v-container>
  <v-row>
    <v-col>
<v-datetime-picker
              label="From"
              v-model="start"
              dateFormat="dd/MM/yyyy"
              timeFormat="hh:mm aa"
              :text-field-props="textFieldProps"
              class="pa-10"
            >
              <template v-slot:dateIcon>
                Date
              </template>
              <template v-slot:timeIcon>
                Time
              </template>
            </v-datetime-picker>
    </v-col>

    <v-col >
      
            <v-btn color="primary" :loading="loading" @click="getAvailabilityFileList(sub)" right>
              Search
            </v-btn>
    </v-col>

  </v-row>
  <v-row>
    <v-col>
            <v-text-field
              v-model="availabilityFileListFilter"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
    </v-col>
  </v-row>
</v-container>


          <v-data-table
            :items="availabilityFileList"
            :headers="availabilityFileListHeaders"
            :search="availabilityFileListFilter"
            :options="availabilityFileListOptions"
            item-key="Key"
            :loading="loading"
          >
            <template
              v-slot:item.LastModified="{ item }"
            >{{new Date(item.LastModified).toLocaleString("en-AU")}}</template>
            <template v-slot:item.Size="{item}">{{bytesToSize(item.Size)}}</template>
            <template v-slot:item.Key="{item}">
              <router-link
                :to="{ name: 'AvailabilityDetails', params: { sub, key: item.Key }}"
              >{{item.Key}}</router-link>
            </template>
          </v-data-table>
        </v-card>
      </v-col>

    <v-col cols="4">

            <template>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">
                                  <v-btn
                                  :disabled="!nextToken"
              v-if="nextToken"
              :loading="loading"
              color="success"
              small
              @click="getAvailabilityFileList(sub, nextToken)"
            >
              Get More Results
            </v-btn>
                    </span>
                  </template>
                  <span>Your search matched more than 1000 results. Get the next batch of results for your search by clicking here.</span>
                </v-tooltip>
            </template>
    </v-col>    
    </v-row>
  </v-container>
</template>


<script>
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";

export default {
  props: {
    pmsConnDetails: Object,
  },
  data: function () {
    return {
      sub: "",
      loading: false,
      status: {},

      start: new Date(),
      availabilityFileList: [],
      availabilityFileListOptions: {
        sortBy: ["LastModified"],
        sortDesc: [true],
      },
      availabilityFileListFilter: "",
      availabilityFileListHeaders: [
        {
          text: "Processed",
          value: "LastModified",
        },
        {
          text: "Size (bytes)",
          value: "Size",
        },
        {
          text: "Key",
          value: "Key",
        },
        {
          text: "ETag",
          value: "ETag",
        },
      ],
      textFieldProps: {
        appendIcon: 'mdi-calendar',
        dense: true,
        class: ''
      },
      nextToken: ""
    };
  },
  created: async function () {
    this.sub = this.$route.params.sub;


    const start = new Date();
    start.setHours(0, 0, 0);
    start.setDate(start.getDate()-3); // 3 days ago by default
    this.start = start;

    this.getAvailabilityFileList(this.sub);
  },
  methods: {
    async getAvailabilityFileList(sub, nextToken) {
      try {
        this.loading = true;
        const fileResult = await API.graphql(
          graphqlOperation(queries.getAvailabilityFileList, { sub, startAfter: this.start?.getTime()?.toString() ?? "", continuationToken: nextToken })
        );

        console.log("getAvailabilityFileList", fileResult, this.start.getTime());

        if (fileResult.data?.getAvailabilityFileList) {
          const result = fileResult.data?.getAvailabilityFileList;
          this.availabilityFileList = result.Contents ?? [];

          this.nextToken = fileResult.data?.getAvailabilityFileList?.NextContinuationToken ?? "";

        } else {
          console.log("error retrieving availabillity file list", fileResult);
          this.handleResponseError("Cannot retrieve the availability file list", fileResult);
        }

        console.log("getAvailabilityFileList", this.availabilityFileList);
      } catch (err) {
        console.log("error retrieving availabillity file list", err);
        this.handleResponseError("Cannot retrieve the availability file list", err);
      }
      finally {
        this.loading=false;
      }
    },
    async handleResponseError(operationDescription, response) {
      console.log("handleResponseError", response);
      const notifyResult = await this.$dialog.notify.error(
        operationDescription,
        {
          position: "top-right",
          timeout: 5000,
          actions: [{ text: "Info", "x-small": true, color: "secondary" }],
        }
      );

      if (notifyResult == "Info") {
        this.$dialog.error({
          text: JSON.stringify(response?.errors || response),
          title: operationDescription,
          icon: "mdi-error",
        });
      }
    },
    bytesToSize(bytes) {
      var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      if (bytes == 0) return "0 Byte";
      var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
      return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
    },
  },
};
</script>